import React from "react";
import SEO from "@/components/SEO";
import ServiceLocationTemplate from "@/components/ServiceLocationTemplate";

const CraigieburnCdbsDentistPage = () => (
  <ServiceLocationTemplate suburbName="Craigieburn" suburbSlug="craigieburn" variant="cdbs-dentist" />
);

export default CraigieburnCdbsDentistPage;
